'use client';

import dynamic from 'next/dynamic'
import { usePathname } from "next/navigation";
import { useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { getCurrentBearerToken } from "@/lib/client-auth";
import { isBlank } from "@/lib/utils";
import HeaderWithTabs from './HeaderWithTabs';

const Header = dynamic(() => import('./Header'), { ssr: false });

export default function HeaderWrapper() {
    const pathname = usePathname();
    const isHome = pathname == '/';
    const isWebviewLanding = pathname.startsWith('/welcome/webview') || pathname.startsWith('/welcome/login') || pathname.startsWith('/webview/landing') || pathname.startsWith('/webview/login');
    const isWelcomeTryIt = pathname.startsWith('/welcome/tryit');
    const isLanding = pathname.startsWith('/login');
    const isStoryRoute = pathname.startsWith('/story');
    const isFeedRoute = pathname.startsWith('/learning-feed');
    const isContactsRoute = pathname.startsWith('/contacts');
    const isWorkbookRoute = pathname.startsWith('/dashboard');
    const isPracticeRoute = pathname.startsWith('/practice');
    const isMobile = useSelector((state: any) => state.app.isMobileScreen);
    const enableNewUi = useSelector((state: any) => state.app.featureFlags?.enableNewUi);
    const currentUser = useSelector((state: any) => state.app.currentUser);
    const [resolved, setResolved] = useState(false);

    const hasAuthToken = useMemo(() => {
        return !isBlank(getCurrentBearerToken());
    }, [currentUser?._id]);

    // Needed to avoid hydration errors
    useEffect(() => {        
        setResolved(true);        
    }, []);
    
    const getHeader = () => {
        if (isWebviewLanding || isWelcomeTryIt) {
            return <></>;
        } else if (enableNewUi && !isLanding && !isPracticeRoute) {
            if (!hasAuthToken && isHome) {
                // Special case for home page with no auth token
                return (
                    <div className="h-0 hidden"><header></header></div>
                );
            } else {
                return <HeaderWithTabs showTabs={isFeedRoute} />;
            }        
        } else {
            return (        
                <Header />
            );
        }
    }

    return <>
        {resolved && getHeader()}
    </>;
}